/**
 * 工具类
 */
import { Message } from 'element-ui'
//消息提示
export const notify = function({
  type = 'info',
  message = '',
  duration = 2000,
  showClose = false,
  onClose = function() {}
}) {
  Message({
    type,
    message,
    duration,
    showClose,
    onClose
  })
}
//关闭消息提示
export const closeNotify = function() {
  Message.close()
}
export function mergeTree(oldList = [], newList = []) {
  const map = new Map()
  // 先把老的放进去
  oldList.forEach(item => {
    map.set(item.value, { ...item })
  })
  // 再合并新的
  newList.forEach(item => {
    if (map.has(item.value)) {
      // 如果有children，递归合并
      if (item.children || map.get(item.value).children) {
        map.get(item.value).children = mergeTree(
          map.get(item.value).children || [],
          item.children || []
        )
      }
    } else {
      map.set(item.value, { ...item })
    }
  })
  return Array.from(map.values())
}
//
export function debounce(func, wait = 1000, immediate = true) {
  let timeout
  let result
  return function(...args) {
    const context = this
    if (timeout) window.clearTimeout(timeout)
    if (immediate) {
      let callNow = !timeout
      timeout = setTimeout(() => {
        timeout = false
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
    return result
  }
}
export function  clearCookie(){
  var date=new Date();
  date.setTime(date.getTime()-10000);
  var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
      for (var i =  keys.length; i--;)
        document.cookie=keys[i]+"=0; expire="+date.toGMTString()+"; path=/";
  }
}
export function IEVersion() {
  var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
  var isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器
  var isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion == 7) {
      return 7
    } else if (fIEVersion == 8) {
      return 8
    } else if (fIEVersion == 9) {
      return 9
    } else if (fIEVersion == 10) {
      return 10
    } else {
      return 6 //IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' //edge
  } else if (isIE11) {
    return 11 //IE11
  } else {
    return -1 //不是ie浏览器
  }
}
//生成 min-max 的随机数
export const randomIntegerInRange = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min

export let hideExport = true